import { useCallback } from "react";
import { AxiosRequestConfig } from "axios";
import { AxiosInstance } from "../_AxiosInstance";

interface UseApiConfig<Data = unknown> extends Omit<AxiosRequestConfig, "data"> {
  data?: Data;
  fetchOnMount?: boolean;
}

interface UseApiOutput<ResponseData, RequestData = unknown> {
  requestFn: (data?: RequestData) => Promise<ResponseData>;
}

const useApi = <ResponseData, RequestData = unknown>(
  config: UseApiConfig<RequestData>,
): UseApiOutput<ResponseData, RequestData> => {
  const requestFn = useCallback(
    (requestData: RequestData = config.data as RequestData) =>
      AxiosInstance.request<ResponseData>({
        ...config,
        data: config.method !== "GET" ? requestData : null,
        params: config.method === "GET" ? requestData : null,
      }).then((res) => res.data),
    [config],
  );

  return { requestFn };
};

export default useApi;
